import React from "react";
import { useSelector } from "react-redux";

import DefaultPageLayout from "components/layouts/default-page-layout";
import useSetUrl from "app/main/admin/hooks/useSetUrl";
import OrgUnitPrimaryHeader from "app/main/orgUnits/components/orgUnit-primary-header";
import ScreenHeader from "components/items/screen-header";
import { getCurrentOrgUnit } from "app/main/orgUnits/reducers/orgUnit.reducers";

import ReferralFormProfileForm from "../components/referralFormProfile-form";

const ReferralFormProfileNewPage = ({
  match: { params: { id, orgUnitType } },
  route,
  history,
}) => {
  useSetUrl(route);
  const orgUnit = useSelector(getCurrentOrgUnit);

  return (
    <>
      <OrgUnitPrimaryHeader orgUnitId={id} />
      <DefaultPageLayout
        header={<ScreenHeader title="Add Referral Form Profile" />}
        content={(
          <ReferralFormProfileForm
            submitLabel="Add"
            onCancel={() => {
              history.push(`/admin/org-units/${orgUnit.orgUnitType}/${id}?tab=referralFormProfiles`);
            }}
            onSucceed={referralFormProfileId => history.push(`/admin/org-units/${orgUnitType}/${id}/referralFormProfiles/${referralFormProfileId}`)}
            orgUnitId={id}
          />
        )}
      />
    </>
  );
};

export default ReferralFormProfileNewPage;
